import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppToastsComponent } from './components/app-toasts/app-toasts.component';
import { NgbPaginationModule, NgbPopoverModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { OtpComponent } from './components/otp/otp.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { AccountDetailComponent } from './components/account-detail/account-detail.component';
import { TransferInvoiceComponent } from './components/transfer-invoice/transfer-invoice.component';
import { ConsolidatedInvoiceComponent } from './components/consolidated-invoice/consolidated-invoice.component';
import { CountdownModule } from 'ngx-countdown';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { PrestamoDetalleComponent } from './components/prestamo-detalle/prestamo-detalle.component';
import { DepositoDetalleComponent } from './components/deposito-detalle/deposito-detalle.component';
import { CuentaInformacionComponent } from './components/cuenta-informacion/cuenta-informacion.component';
import { CuentaChequeComponent } from './components/cuenta-cheque/cuenta-cheque.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TreeviewModule } from 'ngx-treeview';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { PrestamoInformacionComponent } from './components/prestamo-informacion/prestamo-informacion.component';
import { PrestamoMovimientoComponent } from './components/prestamo-movimiento/prestamo-movimiento.component';
import { AsignarMenuModalComponent } from './components/asignar-menu-modal/asignar-menu-modal.component';
import { PrestamoRubrosComponent } from './components/prestamo-rubros/prestamo-rubros.component';
import { PrestamoModalComponent } from './components/prestamo-modal/prestamo-modal.component';
import { DepositoInformacionComponent } from './components/deposito-informacion/deposito-informacion.component';
import { DepositoMovimientoComponent } from './components/deposito-movimiento/deposito-movimiento.component';
import { DepositoChequeComponent } from './components/deposito-cheque/deposito-cheque.component';
import { ParametrizacionVisualizarComponent } from './components/parametrizacion-visualizar/parametrizacion-visualizar.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { NuevaPreguntaComponent } from './components/nueva-pregunta/nueva-pregunta.component';
import { TransferextInvoiceComponent } from './components/transferext-invoice/transferext-invoice.component';
import { PagoPrestamoInvoiceComponent } from './components/pago-prestamo-invoice/pago-prestamo-invoice.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ContactosModalComponent } from './components/contactos-modal/contactos-modal.component';
import { TablaPresuntivaComponent } from './components/tabla-presuntiva/tabla-presuntiva.component';
import { TablaPresuntivaDpfComponent } from './components/tabla-presuntiva-dpf/tabla-presuntiva-dpf.component';
import { CambioContraseniaComponent } from './components/cambio-contrasenia/cambio-contrasenia.component';
import { CuentaMovimientoComponent } from './components/cuenta-movimiento/cuenta-movimiento.component';
import { ContactoWhatsappComponent } from './components/contacto-whatsapp/contacto-whatsapp.component';
import { EstadoCuentaComponent } from './components/estado-cuenta-detalle/estado-cuenta.component';
import { EstadoCuentaRangoComponent } from './components/estado-cuenta-rango/estado-cuenta-rango.component';
import { CertificadosCuentaComponent } from './components/certificados-cuenta/certificados-cuenta.component';
import { AppPasswordVerifyComponent } from './components/app-password-verify/app-password-verify.component';
import { EnmascararCuentaPipe } from './pipes/enmascarar-cuenta.pipe';
import { AccionesRapidasComponent } from './components/acciones-rapidas/acciones-rapidas.component';

defineLocale('es', esLocale);

@NgModule({
  declarations: [
    AppToastsComponent,
    OtpComponent,
    ConfirmModalComponent,
    AccountDetailComponent,
    TransferInvoiceComponent,
    ConsolidatedInvoiceComponent,
    PageNotFoundComponent,
    PrestamoDetalleComponent,
    DepositoDetalleComponent,
    CuentaInformacionComponent,
    CuentaMovimientoComponent,
    CuentaChequeComponent,
    PrestamoInformacionComponent,
    PrestamoMovimientoComponent,
    AsignarMenuModalComponent,
    PrestamoRubrosComponent,
    PrestamoModalComponent,
    DepositoInformacionComponent,
    DepositoMovimientoComponent,
    DepositoChequeComponent,
    ParametrizacionVisualizarComponent,
    SafeHtmlPipe,
    NuevaPreguntaComponent,
    TransferextInvoiceComponent,
    PagoPrestamoInvoiceComponent,
    //PagoServicioInvoiceComponent,
    UnauthorizedComponent,
    ContactosModalComponent,
    TablaPresuntivaComponent,
    TablaPresuntivaDpfComponent,
    CambioContraseniaComponent,
    ContactoWhatsappComponent,
    EstadoCuentaComponent,
    EstadoCuentaRangoComponent,
    CertificadosCuentaComponent,
    AppPasswordVerifyComponent,
    EnmascararCuentaPipe,
    AccionesRapidasComponent
  ],
  imports: [
    CommonModule,
    NgbToastModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    NgbPaginationModule,
    BsDatepickerModule.forRoot(),
    TreeviewModule.forRoot(),
    NgbPopoverModule,
    RouterModule,
  ],
  exports: [
    AppToastsComponent,
    OtpComponent,
    TransferInvoiceComponent,
    TransferextInvoiceComponent,
    ConsolidatedInvoiceComponent,
    PageNotFoundComponent,
    CuentaInformacionComponent,
    CuentaChequeComponent,
    CuentaMovimientoComponent,
    PrestamoInformacionComponent,
    PrestamoMovimientoComponent,
    PrestamoRubrosComponent,
    DepositoInformacionComponent,
    DepositoMovimientoComponent,
    DepositoChequeComponent,
    PagoPrestamoInvoiceComponent,
    //PagoServicioInvoiceComponent,
    TablaPresuntivaComponent,
    TablaPresuntivaDpfComponent,
    ContactoWhatsappComponent,
    EstadoCuentaRangoComponent,
    CertificadosCuentaComponent,
    AppPasswordVerifyComponent,
    EnmascararCuentaPipe,
    AccionesRapidasComponent
  ],
  entryComponents: [
    ConfirmModalComponent,
    PrestamoModalComponent,
    ParametrizacionVisualizarComponent,
    NuevaPreguntaComponent,
    AsignarMenuModalComponent,
    ContactosModalComponent,
    CambioContraseniaComponent
  ]
})
export class CoreModule { }
